export default "__VITE_ASSET__DSjEW0al__"